'use client';

import React, { useEffect } from "react";

const Terms = () => {
  return (
    <div className="pt-6 text-color-2">
      <h1 className="text-3xl font-bold text-center text-color-1 mb-6">
        Terms of Use
      </h1>
      <p className="mb-4">
        Welcome to{" "}
        <span className="font-semibold text-color-1">Centera Tech!</span> By
        accessing or using our website, you agree to comply with and be bound by
        the following Terms of Use. Please read these terms carefully. If you do
        not agree to these terms, you may not use our website or services.
      </p>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            1. General Use
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              The content provided on this website is for informational purposes
              only and does not constitute professional advice or an agreement
              to provide services.
            </li>
            <li>
              You are responsible for ensuring that your use of this website
              complies with all applicable laws and regulations.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            2. Intellectual Property
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              All content on this website, including but not limited to text,
              graphics, logos, images, and software, is the property of{" "}
              <span className="font-semibold">Centera Tech</span> or its
              licensors and is protected by intellectual property laws.
            </li>
            <li>
              You may not reproduce, distribute, modify, or create derivative
              works from any content on this website without prior written
              permission.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            3. Limitation of Liability
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              Centera Tech shall not be liable for any direct, indirect,
              incidental, consequential, or punitive damages arising from your
              use of this website or any errors or omissions in its content.
            </li>
            <li>
              We make no warranties or guarantees regarding the accuracy,
              reliability, or completeness of the information on this website.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            4. Third-Party Links
          </h2>
          <p>
            This website may contain links to third-party websites for your
            convenience. Centera Tech does not endorse or assume responsibility
            for the content, products, or services of any third-party sites.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            5. Privacy Policy
          </h2>
          <p>
            Your use of this website is subject to our Privacy Policy, which
            outlines how we collect, use, and protect your information.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            6. Changes to Terms
          </h2>
          <p>
            Centera Tech reserves the right to modify these Terms of Use at any
            time. Changes will be effective immediately upon posting. Your
            continued use of the website constitutes acceptance of the updated
            terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            7. Governing Law
          </h2>
          <p>
            These Terms of Use are governed by the laws of The United States.
            Any disputes arising from these terms shall be resolved in the
            courts of The United States.
          </p>
        </section>
      </div>

      <footer className="mt-8">
        <p>
          For questions about these terms, please contact us at{" "}
          <a
            href="mailto:support@centera.tech"
            className="text-color-1 underline"
          >
            support@centera.tech
          </a>
          .
        </p>
      </footer>
    </div>
  );
};

export default Terms;
